function CardHeaderButton({ text, customFn, className }) {
  return (
    <button
      className={`${className} btn btn-info`}
      onClick={() => customFn && customFn()}
    >
      {text}
    </button>
  )
}

export default CardHeaderButton
